import { FetchStatus, QueryStatus } from '@tanstack/react-query';

export const getLoadingState = (
  isLoading: boolean,
  fetchStatus: FetchStatus
) => {
  return isLoading && fetchStatus !== 'idle';
};

// V4 - disabled queries are now 'loading' as default see: https://github.com/TanStack/query/issues/3584
export const getQueryStatus = (
  queryStatus: QueryStatus,
  fetchStatus: FetchStatus
) => {
  if (queryStatus === 'loading' && fetchStatus !== 'idle') return 'success';
  return queryStatus;
};
